import { AlertCircle } from "lucide-react";

/**
 * Consistent form-level error banner.
 *
 * Use for errors that apply to the entire form (API failures, auth errors)
 * rather than individual field validation (use Input's error prop for that).
 *
 * Usage:
 *   {error && <FormError message={error} />}
 */
export default function FormError({
  message,
  className = "",
}: {
  message: string;
  className?: string;
}) {
  if (!message) return null;

  return (
    <div
      role="alert"
      className={`flex items-start gap-2.5 rounded-lg border border-red-200 dark:border-red-800/50 bg-red-50 dark:bg-red-950/20 px-4 py-3 text-sm text-red-700 dark:text-red-300 ${className}`}
    >
      <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" />
      <span>{message}</span>
    </div>
  );
}
